export default {
  routes: [
    {
      name: 'educations',
      path: '/directory/educations',
      component: () => import('./views/TheEducations.vue'),

    },

    {
      name: 'education',
      path: '/directory/educations/:uuid',
      component: () => import('./views/TheEducation.vue'),
    },
  ]
}
